'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image, SectionList} from 'react-native';
import CardSection from '../cardSection';
import { observer, inject } from 'mobx-react';
import styles from './style';
import { QToast } from '@qnpm/q-components';
import {logPageTime} from "../../../../common/utils";


@inject(stores => {
    const {lowPriceDataStore} = stores,
        {lowPriceData, loading, successToast, selectedFilter} = lowPriceDataStore,
        {items} = lowPriceData;

    return {
        items: items,
        renderItems: items && items.map((item)=>{return  {
            title: item.title,
            data: item
        }}),
        selectedFilter,
        loading,
        successToast
    };
})

@observer
class CardSectionList extends Component {
    constructor(props) {
        super(props);
        this.itemsY = [];
        this.cardListY = 0;
    }

    onTableLayout = (e, index) => {
        let {items = []} = this.props;

        this.itemsY[index] = e.nativeEvent.layout.y;

        if (this.itemsY.filter((item) => {return typeof item !== undefined}).length === items.length) {
            //所有组件都onLayout之后计算锚点,即计算组件相对滚动父元素的y值
            let p = [];
            this.itemsY.forEach((y, index) => {
                let result = {
                    anchor: items[index].anchor,
                    y: y
                };
                p.push(result);
            });
            this.props.setLayout(p);
        }
    };

    onCardListLayout = (e) => {
        this.cardListY = e.nativeEvent.layout.y;
        this.props.setCardListY(this.cardListY)
    };


    componentDidUpdate() {
        this.itemsY = [];
        let {items} = this.props || {};
        if (items && items.length && !this.hasLogPageComplete) {
            this.hasLogPageComplete = true;
            GodEye.log({
                r: 'pagecomplete'
            });
            logPageTime({
                r: 'pagecomplete',
                time: new Date().getTime() - window.__root_time
            })

            logPageTime({
                r: 'rendertime',
                time: new Date().getTime() - this.startRenderTime
            })
        }
    }

    render() {
        this.startRenderTime = new Date().getTime();
        let {items, selectedFilter, successToast} = this.props;
        successToast && QToast.show(successToast);
        if (!items || !items.length) {
            return <View/>
        }
        return (
            <View style={styles.cheapList} onLayout={this.onCardListLayout}>
                {
                    items.map((value, index) => {
                        return <CardSection data={value} onLayout={this.onTableLayout} key={index} index={index} selectedFilter={selectedFilter} />
                    })
                }
            </View>
        )
    }
}

export default CardSectionList;
